import request from '@/utils/request'

export function GetContentTypeOptions () {
  return request({
    url: '/api/memo/GetContentTypeOptions',
    method: 'get'
  })
}